import { CUSTOMER } from "entities/user/role";
import useRole from "hooks/useRole";
import { DefaultPermission } from "utils/permission";

export default function usePlanPermissions(): DefaultPermission {
  const { hasNotRole } = useRole();

  return {
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canList: hasNotRole(CUSTOMER),
    canShow: hasNotRole(CUSTOMER),
  };
}
